import { render, staticRenderFns } from "./ApplicationDetail.vue?vue&type=template&id=7060adba&scoped=true"
import script from "./ApplicationDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplicationDetail.vue?vue&type=style&index=0&id=7060adba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7060adba",
  null
  
)

export default component.exports